// extracted by mini-css-extract-plugin
export var callCard = "_p5-0";
export var callMessageButton = "_p5-1";
export var helpIcon = "_p5-3";
export var helpIconContainer = "_p5-4";
export var verticalDivider = "_p5-2";